import React from 'react';
import { View } from 'react-native';
import FullPageSimulator from '../../FullPageSimulator';
import CurrencyAmountLine from '../../../AuxiliaryComponent/AmountSim/CurrencyAmountLine';

//= ========================================================================
const ChangeCurrencyAmountFP = ({
  globJSON,
  simPlatform, subCategoryId, strTitle = '', slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const service = globJSON.configurations.services[subCategoryId];
  const amount = service.amount || service.amount_package;

  const myStyles = {
    title: {
      width: 217,
      height: 20,
      fontSize: 16,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: colors.primary_font_color,

    },
    container: {
      width: 240,
      borderTopWidth: 1,
      borderTopColor: colors.border_color,
    },
  };

  //= ====================================================================

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={amount.title || amount.how_much_to_transfer}
      TopTitle={strTitle}
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.container}>
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr="$"
          withIcon
          simPlatform
        />
        <CurrencyAmountLine
          globJSON={globJSON}
          currencyStr="KHR"
          simPlatform={simPlatform}
        />
      </View>
    </FullPageSimulator>
  );
};

export default ChangeCurrencyAmountFP;
